import { useCallback, useEffect, useRef, useState } from 'react';
import { useAiScheduleAccess } from '@frontend/ai-receptionist-settings';
import { OperatoryAvailabilityCallout } from './schedule-operatory-availability-callout';

export const CalloutContainer = ({
  selectedOption,
  children,
}: {
  selectedOption: string;
  children: React.ReactNode;
}) => {
  const [shouldOpenCallout, setOpenCallout] = useState(false);
  const calloutRef = useRef<HTMLDivElement>(null);
  const operatoryRef = useRef<HTMLButtonElement | null>(null);
  const closeTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const { hasAiScheduleAccess } = useAiScheduleAccess();
  const showOperatoryAvailabilityCallout = selectedOption !== 'operatory' && shouldOpenCallout && !hasAiScheduleAccess;

  useEffect(() => {
    const root = calloutRef.current;
    if (!root) return;

    operatoryRef.current = root.querySelector('[data-operatory-button]');
  }, [children]);

  const clearCloseTimeout = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
  };

  const handleMouseEnter = useCallback(() => {
    // Clear any pending close
    clearCloseTimeout();
    setOpenCallout(true);
  }, []);

  const handleMouseLeave = useCallback((event: React.MouseEvent) => {
    const nextTarget = event.relatedTarget as Node | null;
    const inTrigger = !!(operatoryRef.current && nextTarget && operatoryRef.current.contains(nextTarget));

    if (inTrigger) {
      return;
    }
    // Delay close to allow mouse movement to popover
    closeTimeoutRef.current = setTimeout(() => {
      setOpenCallout(false);
    }, 100);
  }, []);

  return (
    <div ref={calloutRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {showOperatoryAvailabilityCallout && (
        <OperatoryAvailabilityCallout
          shouldOpenCallout={shouldOpenCallout}
          setOpenCallout={setOpenCallout}
          anchorRef={operatoryRef}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      )}
      {children}
    </div>
  );
};
